<!--
목적 : 확장검색 기능을 지원하는 컴포넌트
Detail :
 *
examples:
 *
-->
<template>
  <div class="td-input-column">
    <div v-if="!isShow" class="pad-txt-label">
      <div 
        class="table-td-textlabel"
        tabindex="0" 
        v-html="$comm.convertEnter(props.row[col.name])"
        @focus="textareafocus()"
        @click="textareafocus()" >
      </div>
    </div>
    <div v-if="editable&&isShow">
      <q-input
        class="table-td-text-grid"
        ref="input-column"
        type="textarea"
        outlined autofocus
        :autogrow="true"
        :disable="disabled"
        v-model="props.row[col.name]"
        @keyup.enter.stop
        @input="datachange(props, col)"
        @blur="textareafocusout()"
      ></q-input>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
export default {
  /* attributes: name, components, props, data */
  name: 'c-textarea-column',
  props: {
    name: {
      type: String,
    },
    // 쓰기 권한 여부
    editable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    col: {
      type: Object,
      default: function() {
        return {
          taskClassCd: '',
          taskKey: '',
        }
      }
    },
    props: {
      type: Object,
      default: function() {
        return { }
      }
    },
  },
  data() {
    return {
      isShow: '',
    };
  },
  computed: {
  },
  watch: {
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {},
  destroyed() {},
  updated() {
  },
  /* methods */
  methods: {
    init() {
      // url setting
    },
    textareafocus() {
      if (this.editable&&!this.disabled) {
        this.$set(this.$data, 'isShow', true)
      }
    },
    textareafocusout() {
      this.$set(this.$data, 'isShow', false)
    },
    datachange() {
      this.$emit('datachange')
    }
  },
};
</script>